/**
 * Created by 王国栋 wgdsk on 2018/6/14.
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userNeme: "",
        cartCount: 0
    },
    mutations: {
        upUserName(state, userNeme) {
            state.userNeme = userNeme;
        },
        upcartCount(state, count) {
            state.cartCount = count;
        }
    },
})